import { render, staticRenderFns } from "./KPromocodesList.vue?vue&type=template&id=c253ddd8&"
import script from "./KPromocodesList.vue?vue&type=script&lang=js&"
export * from "./KPromocodesList.vue?vue&type=script&lang=js&"
import style0 from "./KPromocodesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports